import * as constants from "./constants";

export interface AuthState {
    isLoading: boolean;
    errors: any;
    isAuthenticated: boolean;
    user: any;
    access_token: string | null;
    refresh_token: string | null;
    isRegisterLoading: boolean;
    register: any;
    registerError: any;
    isVerificationOtpLoading: boolean;
    verificationOtp: any;
    verificationOtpError: any;
    isForgotPasswordLoading: boolean;
    forgotPassword: any;
    forgotPasswordError: any;
    isResetPasswordLoading: boolean;
    resetPassword: any;
    resetPasswordError: any;
}

export const initialState: AuthState = {
    isLoading: false,
    errors: null,
    isAuthenticated: false,
    user: null,
    access_token: null,
    refresh_token: null,
    isRegisterLoading: false,
    register: null,
    registerError: null,
    isVerificationOtpLoading: false,
    verificationOtp: null,
    verificationOtpError: null,
    isForgotPasswordLoading: false,
    forgotPassword: null,
    forgotPasswordError: null,
    isResetPasswordLoading: false,
    resetPassword: null,
    resetPasswordError: null,
}

const authReducer = (state = initialState, action: any): AuthState => {
    switch (action.type) {

        case constants.LOGIN_REQUESTING:
            return {
                ...state,
                isLoading: true,
            };
        case constants.LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                isLoading: false,
                user: action.payload?.user,
                access_token: action.payload?.access_token,
                refresh_token: action.payload?.refresh_token,
                errors: null
            };

        case constants.LOGIN_FAILED:
            return {
                ...state,
                isLoading: false,
                isAuthenticated: false,
                errors: action.error,
                user: null,
                access_token: null,
                refresh_token: null,
            };

        // Inscription
        case constants.REGISTER_REQUESTING:
            return {
                ...state,
                isRegisterLoading: true,
            };

        case constants.REGISTER_SUCCESS:
            return {
                ...state,
                isRegisterLoading: false,
                register: action.payload,
                registerError: null,
            };

        case constants.REGISTER_FAILED:
            return {
                ...state,
                isRegisterLoading: false,
                register: null,
                registerError: action.error,
            };

        // Verification OTP
        case constants.VERIFICATION_OTP_REQUESTING:
            return {
                ...state,
                isVerificationOtpLoading: true,
            };
        case constants.VERIFICATION_OTP_SUCCESS:
            return {
                ...state,
                isVerificationOtpLoading: false,
                verificationOtp: action.payload,
                verificationOtpError: null,
            };
        case constants.VERIFICATION_OTP_FAILED:
            return {
                ...state,
                isVerificationOtpLoading: false,
                verificationOtp: null,
                verificationOtpError: action.error
            };

        // Forgot password
        case constants.FORGOT_PASSWORD_REQUESTING:
            return {
                ...state,
                isForgotPasswordLoading: true,
            };
        case constants.FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                isForgotPasswordLoading: false,
                forgotPassword: action.payload,
                forgotPasswordError: null,
            };
        case constants.FORGOT_PASSWORD_FAILED:
            return {
                ...state,
                isForgotPasswordLoading: false,
                forgotPassword: null,
                forgotPasswordError: action.error
            };

        // Reset password
        case constants.RESET_PASSWORD_REQUESTING:
            return {
                ...state,
                isResetPasswordLoading: true,
            };
        case constants.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                isResetPasswordLoading: false,
                resetPassword: action.payload,
                resetPasswordError: null,
            };
        case constants.RESET_PASSWORD_FAILED:
            return {
                ...state,
                isResetPasswordLoading: false,
                resetPassword: null,
                resetPasswordError: action.error
            };

        // Logout
        case constants.LOGOUT:
            return initialState;

        default:
            return state;
    }
}

export default authReducer;
